import { SvgIcon, SxProps } from "@mui/material";
import InternetExposed from "@mui/icons-material/LanguageOutlined";
import AdminUser from "@mui/icons-material/PersonOutlined";
import AccessToKeys from "@mui/icons-material/KeyOutlined";
import ServiceRunning from "@mui/icons-material/PlayCircleOutlined";
import {
  Add as AddIcon,
  Close as CloseIcon,
  Delete as DeleteIcon,
  Edit as EditIcon,
  MoreHoriz as MoreHorizIcon,
  Refresh as RefreshIcon,
  SaveAlt as SaveAltIcon,
  IosShare as IosShareIcon,
  Balance as BalanceIcon,
} from "@mui/icons-material";
import {
  ContainerEnvironmentIcon,
  DatabaseAccessIcon,
  DefensiveIcon,
  EndOfLifeIcon,
  ExploitableIcon,
  PlusIcon,
  RemoteExecutionIcon,
  SensitiveDataIcon,
} from "~/icons";

type DynamicIconProps = {
  iconId: IconButtonType | null | undefined;
  size?: string;
  sx?: SxProps;
  defaultIcon?: typeof SvgIcon;
};

export const DynamicButtonIcon = ({
  iconId,
  size,
  sx = {},
  defaultIcon = MoreHorizIcon,
}: DynamicIconProps) => {
  const commonProps = {
    "data-testid": "icon-button",
    sx: {
      fontSize: size || 24,
      ...sx,
    },
  };

  const iconKey = iconId || IconButtonType.Default;

  const iconsDictionary: Record<
    IconButtonType,
    typeof SvgIcon | React.ComponentType
  > = {
    [IconButtonType.Close]: CloseIcon,
    [IconButtonType.Default]: SvgIcon,
    [IconButtonType.Delete]: DeleteIcon,
    [IconButtonType.Edit]: EditIcon,
    [IconButtonType.Download]: SaveAltIcon,
    [IconButtonType.Refresh]: RefreshIcon,
    [IconButtonType.InternetFacing]: InternetExposed,
    [IconButtonType.Exploitable]: ExploitableIcon,
    [IconButtonType.DbAccess]: DatabaseAccessIcon,
    [IconButtonType.UserRisk]: AdminUser,
    [IconButtonType.AssetInUse]: ServiceRunning,
    [IconButtonType.CodeExecution]: RemoteExecutionIcon,
    [IconButtonType.SensitiveData]: SensitiveDataIcon,
    [IconButtonType.Credentials]: AccessToKeys,
    [IconButtonType.Containers]: ContainerEnvironmentIcon,
    [IconButtonType.Eol]: EndOfLifeIcon,
    [IconButtonType.Defensive]: DefensiveIcon,
    [IconButtonType.More]: AddIcon,
    [IconButtonType.Plus]: PlusIcon,
    [IconButtonType.IosShare]: IosShareIcon,
    [IconButtonType.Balance]: BalanceIcon,
  };

  let Icon = iconsDictionary[iconKey] || defaultIcon;

  return <Icon {...commonProps} />;
};

export enum IconButtonType {
  More = "MORE",
  Close = "CLOSE",
  Default = "DEFAULT",
  Delete = "DELETE",
  Download = "DOWNLOAD",
  Edit = "EDIT",
  Refresh = "REFRESH",
  // Risk Factor Icons
  InternetFacing = "INTERNET_FACING",
  Exploitable = "EXPLOITABLE",
  DbAccess = "DB_ACCESS",
  UserRisk = "USER_RISK",
  AssetInUse = "ASSET_IN_USE",
  CodeExecution = "CODE_EXECUTION",
  SensitiveData = "SENSITIVE_DATA",
  Credentials = "CREDENTIALS",
  Containers = "CONTAINERS",
  Eol = "EOL",
  Defensive = "DEFENSIVE",
  Plus = "PLUS",
  IosShare = "IOS_SHARE",
  Balance = "BALANCE",
}
